/**
 * MITT KONTO — vem är jag, var är jag med, och vilken telefon är det här.
 *
 * TRE SAKER, OCH DE SVARAR PÅ RIKTIGA FRÅGOR:
 *
 *   KONTOT      Namnet är det som står bredvid varje rad du lägger in och det
 *               chefen ser i attestkön. E-posten är den som får
 *               inloggningslänken — byts den byts inloggningen.
 *
 *   FIRMORNA    Alla firmor kontot är med i, med rollen i var och en. En
 *               inhyrd (beslut 17) är anställd någon annanstans och kan vara
 *               med i flera; därför står rollen PER FIRMA och aldrig som en
 *               egenskap hos personen.
 *
 *   ENHETEN     device_id är halva idempotensnyckeln (beslut 09): sync_op_log
 *               slår upp på (op_id, account_id, device_id). När en sparning
 *               beter sig konstigt är det FÖRSTA frågan supporten ställer, och
 *               därför ska talet gå att läsa upp ur telefonen utan
 *               utvecklarverktyg.
 *
 * NAMNET GÅR INTE ATT ÄNDRA HÄR ÄN. UPDATE_ACCOUNT står i kontraktet och är
 * byggd i workern; skärmen behöver ett fält, en op_id och en granskare. Se
 * LUCKOR i överlämningen — den är liten, men den är inte gjord.
 */

import { Installningsrad, Knapp, Listrad, Rubrik, Tomtext, Yta } from '../ui';
import { enhetsId } from '../api';
import { tillArbetsdag, visaDagMedAr } from '../app/datum';
import { useInloggad, useSession } from '../app/session';
import { PRENUMERATIONSNAMN, ROLLNAMN } from './oversikt';

export const Profil = () => {
  const { konto, firmor, aktiv } = useInloggad();
  const { bytFirma, loggaUt } = useSession();

  return (
    <>
      <Rubrik titel={konto.name} under={konto.email} />

      <Yta rubrik="Kontot">
        <Installningsrad etikett="Namn" varde={konto.name} />
        <Installningsrad etikett="E-post" varde={konto.email} />
        {/* Året skrivs ut: visaDag ger "Måndag 2 mars", och för ett datum som
            kan vara flera år gammalt räcker inte det. Formen är app/datum.ts:s
            egen — samma som prenumerationens ankardatum använder. */}
        <Installningsrad
          etikett="Med sedan"
          varde={visaDagMedAr(tillArbetsdag(konto.created_at))}
        />
      </Yta>

      <Yta rubrik="Firmor" rakning={`${firmor.length} st`}>
        {firmor.map((f) => (
          <Listrad
            key={f.id}
            titel={f.name}
            bi={f.is_owner ? '· ägare' : undefined}
            under={`${ROLLNAMN[f.role]} · ${PRENUMERATIONSNAMN[f.subscription_status]}`}
            // "vald" och inte "aktiv": prenumerationen kan också heta aktiv,
            // och två ord som betyder olika saker får inte se likadana ut.
            varde={f.id === aktiv.id ? 'vald' : undefined}
            onClick={f.id === aktiv.id ? undefined : () => bytFirma(f.id)}
          />
        ))}
      </Yta>

      <Yta rubrik="Den här telefonen" tyst>
        <Installningsrad etikett="Enhet" varde={enhetsId()} />
      </Yta>

      <Knapp variant="stor-tyst" onClick={loggaUt}>
        Logga ut
      </Knapp>

      <Tomtext>
        Enhetens id sitter i den här telefonen och följer inte med till en
        annan. Det är det som gör att en sparning som skickats om inte blir
        två rader.
      </Tomtext>
    </>
  );
};
